import AmountButton from '~/javascripts/components/DonateForm/AmountButton';
import AmountInputWithError from '~/javascripts/components/AmountInputWithError';
import cx from 'classnames';
import store from '~/javascripts/store.js';
import { observer } from 'mobx-react';
import { reaction } from 'mobx';

const DonateFormAmountButtons = observer(
  class DonateFormAmountButtons extends AmountInputWithError {
    constructor(props) {
      super(props);
      this.setDonateFormAmount();

      this.resetDonateFormAmountDisposer = reaction(
        () => [
          store.donateFormButtonAmounts.optimizelyParams,
          store.donateForm.optimizelyParams,
          store.donateForm.isAnnual,
        ],
        () => {
          this.setDonateFormAmount();
          const parsley = $(this.amountInput).parsley();
          if (parsley != undefined) {
            parsley.reset();
          }
        }
      );
    }

    setDonateFormAmount = () => {
      store.donateForm.showOtherAmountInput = false;
      if (
        !store.donateForm.customDefaultAmountsPresent &&
        !store.donateForm.showAmountInputWithAmountButtons
      ) {
        store.donateForm.amount =
          store.donateFormButtonAmounts.displayAmounts.highlight;
      }
    };

    handleOtherAmountButtonClick = () => {
      store.donateForm.amount = null;
      store.donateForm.showOtherAmountInput = true;
      store.donateForm.isWpsAmountButtonSelected = false;
      setTimeout(() => {
        if (this.amountInput) {
          this.amountInput.focus();
        }
      }, 1);
    };

    handleWpsAmountButtonClick = () => {
      store.donateForm.amount = store.donateForm.wpsAmount;
      store.donateForm.showOtherAmountInput = false;
      store.donateForm.isWpsAmountButtonSelected = true;
    };

    componentWillUnmount() {
      this.resetDonateFormAmountDisposer();
    }

    render() {
      const { maxAmount, readOnly, mini } = this.props;

      const {
        amount,
        amountButtonSubscriptionPeriod,
        campaignId,
        currencyName,
        currencyUnit,
        isSubscription,
        minimumAmount,
        showOtherAmountInput,
        hideWpsAmountButton,
      } = store.donateForm;

      return (
        <div>
          <div
            className={cx('amount-wrapper', {
              'mini-button-wrapper': mini,
            })}
          >
            <div className='amount-buttons-wrapper'>
              {store.donateFormButtonAmounts.displayAmounts.values.map(
                (amount) => (
                  <AmountButton
                    highlighted={
                      amount == store.donateForm.amount && !showOtherAmountInput
                    }
                    key={amount}
                    value={amount}
                  />
                )
              )}

              {!mini && (
                <>
                  <a
                    className={cx(
                      'button button--grey-20 other-amount-button',
                      {
                        hidden: showOtherAmountInput,
                      }
                    )}
                    onClick={this.handleOtherAmountButtonClick}
                  >
                    Other amount
                  </a>
                  <div
                    className={cx(
                      `input-wrapper lh donate-amount ${campaignId}`,
                      {
                        hidden: !showOtherAmountInput,
                      }
                    )}
                  >
                    <label htmlFor='amount'>Donation Amount</label>
                    <div className='input-field-container'>
                      <span className='preinput'>{currencyUnit}</span>
                      <input
                        data-amount='true'
                        data-parsley-currency={`${minimumAmount},${maxAmount}`}
                        data-parsley-error-message={this.errorMsg(
                          isSubscription,
                          amount
                        )}
                        data-parsley-errors-container={`.donate-amount.${campaignId} .error`}
                        name='amount'
                        onChange={(e) =>
                          (store.donateForm.amount = parseFloat(e.target.value))
                        }
                        placeholder='Other'
                        readOnly={readOnly}
                        ref={(el) => (this.amountInput = el)}
                        required='required'
                        step='0.01'
                        type='number'
                        value={amount || ''}
                      />
                      <span className='postinput'>
                        <span className='uppercase'>{currencyName}</span>
                        {amountButtonSubscriptionPeriod}
                      </span>
                    </div>
                    <div className='error' />
                  </div>
                  {!hideWpsAmountButton && (
                    <a
                      className={cx(
                        'amount-button button button--grey-20 w-full wps-amount-button',
                        {
                          hidden: isSubscription,
                          selected: store.donateForm.isWpsAmountButtonSelected,
                        }
                      )}
                      onClick={this.handleWpsAmountButtonClick}
                    >
                      Sponsor an entire water project
                    </a>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      );
    }
  }
);

export default DonateFormAmountButtons;
